module.exports = __webpack_public_path__ + "img/emaster.dbe9abc0.png";